var VectorLayer = require("./VectorLayer"),
    ol = require("openlayers"),
    Chart  = require("chart.js"),
    _ = require("underscore"),
    $ = require("jquery"),
    utils = require("Utils");

var devPixelRatio = 1/utils.getDevicePixelRatio();

var OmsChartsLayer = VectorLayer.extend({

    _setup: function(options){
        var that = this,
            vStyle;

        options || (options = {});

        if('projectLayers' in options){
            that._prjLayers = options.projectLayers;
        }

        if(that._prjLayers && that._prjLayers.getLength() > 0){
            that._prjLayer = that._prjLayers.at(0);

            vStyle = that._prjLayer.get('visualSettings');
            if (!vStyle) {
                throw new Error("Not enough parameters to create a vector layer");
            }

            that.project = that._prjLayer.options.project;

            OmsChartsLayer.__super__._setup.call(that, options);

            // Chart.defaults.global.responsive = false;
            // Chart.defaults.global.tooltips.enabled = false;
            // Chart.defaults.global.legend.display = false;
            // Chart.defaults.global.animation = false;
            // Chart.defaults.global.defaultFontSize = 9;
            // Chart.defaults.global.defaultFontColor = "#333333";
            // Chart.defaults.global.defaultColor = "#666666";
            // Chart.defaults.global.elements.arc.borderWidth = 1;

            // колонки, по которым будем строить графики
            that.columnStyles = [];
            var a=0;
            vStyle.classesSettings.columns.forEach(function(column){
                that.columnStyles.push({
                    id: column.id,
                    color: column.color,
                    sort: a
                });
                a++;
            });

            //колонка, по которой будет считаться размер графиков
            if (vStyle.classesSettings.sizeType == 3) {
                that.sizeColumn = vStyle.classesSettings.sizeColumn;
            }

            that.switchLayerSource();
            that.setLayerStyle();
        }

        return that;
    },

    updateLayer: function() {
        var that = this,
            options = {};

        $.extend(options, that.options);
        that._prjLayer.project.loadStructure(that._prjLayer.get('code')).then(function (str) {
            var fields = [];
            $.each(str, function(id, el) {
                fields.push(el.code);
            });
            options.fields = options.fields.concat(fields);
            return that._prjLayers.at(0).loadObjects(options);
        }).then(function () {
            that._olSource.clear();
            that._olSource.addFeatures(that.getFeatures());
            that.setLayerStyle();
        });
    },

    setChartDefaults: function() {
        Chart.defaults.global.responsive = false;
        Chart.defaults.global.tooltips.enabled = false;
        Chart.defaults.global.legend.display = false;
        Chart.defaults.global.animation = false;
        Chart.defaults.global.defaultFontSize = 9;
        Chart.defaults.global.defaultFontColor = "#333333";
        Chart.defaults.global.defaultColor = "#666666";
        Chart.defaults.global.elements.arc.borderWidth = 1;
    },

    onAdd: function(view){
        var that = this;
        that.map = view.getMap();
        that.map.getView().on('change:resolution', function(){
            that.switchLayerSource();
        });
    },

    switchLayerSource: function(){
        var that = this;

        if (!that.map) {
            return;
        }
        that._olLayer.setSource(that._olSource);
    },

    /**
     *
     */
    _createPieChart: function(canvas, feature) {
        var that = this,
            data = [],
            labels = [],
            colors = [],
            value;

        var pixelRatio = that.pixelRatio ? that.pixelRatio : devPixelRatio;

        var options = {
            animation : false,
            cutoutPercentage:-1
        };

        that.columnStyles.forEach(function(column) {
            if(that.newArray[column.sort] == column.id) {
                value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
            }else {
                value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
            }
            if (value != null) {
                data.push(typeof value === 'boolean' ? +value : value);
                colors.push(column.color);
                labels.push("");
            }
        });

        if (data.length == 0) {
            canvas.attr('no-data', 1);
            return;
        }

        var chartData = {
            labels: labels,
            datasets: [
                {
                    data: data,
                    backgroundColor: colors
                }
            ]
        };

        // если график строится только по одной колонке, убираем бордер у сегментов и рисуем один общий бордер
        if (that.columnStyles.length == 1) {
            chartData.datasets[0].borderWidth = [0];
        }

        new Chart(canvas[0].getContext("2d"), {
            type: 'pie',
            data: chartData,
            options: options
        });

        if (that.columnStyles.length == 1) {
            var obCanvas = canvas[0].getContext('2d');
            obCanvas.beginPath();
            obCanvas.arc(canvas[0].width*pixelRatio/2, canvas[0].width*pixelRatio/2, (canvas[0].width/2-1)*pixelRatio, 0, 2*Math.PI, false);
            obCanvas.lineWidth = 1.1;
            obCanvas.strokeStyle = '#fff';
            obCanvas.stroke();
        }
    },


    _createLineChart: function(canvas, feature) {
        var that = this,
            data = [],
            value,
            labels = []; //библиотека требует эту лабуду

        var options = {
            scales: {
                xAxes: [{
                    display: that._prjLayer.get('visualSettings')['classesSettings'].showScale,
                    gridLines: {
                        color: "rgba(0,0,0,0)"
                    }
                }],
                yAxes: [{
                    display: that._prjLayer.get('visualSettings')['classesSettings'].showScale,
                    gridLines: {
                        color: "rgba(0,0,0,0)"
                    },
                    ticks:{
                        maxTicksLimit: 6,
                        padding: 3
                    }
                }]
            }
        };

        //влияет на размер графика без шкалы
        if (that._prjLayer.get('visualSettings')['classesSettings'].showScale) {
            options.scales.yAxes[0].ticks.suggestedMin = that.minMaxScaleValues[0];
            options.scales.yAxes[0].ticks.suggestedMax = that.minMaxScaleValues[1]
        } else {
            options.scales.yAxes[0].ticks.min = that.minMaxScaleValues[0];
            options.scales.yAxes[0].ticks.max = that.minMaxScaleValues[1]
        }

        that.columnStyles.forEach(function(column) {
            if(that.newArray[column.sort] == column.id) {
                value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
            }else {
                value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
            }
            if (value != null) {
                data.push(typeof value === 'boolean' ? +value : value);
                labels.push("");
            }
        });

        if (data.length == 0) {
            canvas.attr('no-data', 1);
            return;
        }

        var chartData = {
            labels: labels,
            datasets: [
                {
                    fill:false,
                    lineTension: 0.3,
                    borderColor: that.columnStyles[0].color,
                    pointBackgroundColor: that.columnStyles[0].color,
                    pointRadius: 1,
                    data: data
                }
            ]
        };

        new Chart(canvas[0].getContext("2d"), {
            type: 'line',
            data: chartData,
            options: options
        });
    },


    _createBarChart: function(canvas, feature) {
        var that = this,
            data = [],
            value;

        var options = {
            scales: {
                xAxes: [{
                    display: that._prjLayer.get('visualSettings')['classesSettings'].showScale,
                    categoryPercentage: 0.9
                }],
                yAxes: [{
                    display: that._prjLayer.get('visualSettings')['classesSettings'].showScale,
                    gridLines: {
                        color: "rgba(0,0,0,0)"
                    },
                    ticks: {
                        maxTicksLimit: 6,
                        padding: 3
                    }
                }]
            }
        };

        //влияет на размер графика без шкалы
        if (that._prjLayer.get('visualSettings')['classesSettings'].showScale) {
            options.scales.yAxes[0].ticks.suggestedMin = that.minMaxScaleValues[0];
            options.scales.yAxes[0].ticks.suggestedMax = that.minMaxScaleValues[1]
        } else {
            options.scales.yAxes[0].ticks.min = that.minMaxScaleValues[0];
            options.scales.yAxes[0].ticks.max = that.minMaxScaleValues[1]
        }


        var visible = false;
        that.columnStyles.forEach(function(column) {
            if(that.newArray[column.sort] == column.id) {
                value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
            }else {
                value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
            }
            visible = visible || value != null;
            data.push({
                backgroundColor: column.color,
                data: [typeof value === 'boolean' ? +value : value]
            });
        });

        if (!visible) {
            canvas.attr('no-data', 1);
            return;
        }

        var chartData = {
            labels: [""],
            datasets: data
        };

        new Chart(canvas[0].getContext("2d"), {
            type: 'bar',
            data: chartData,
            options: options
        });
    },

    _reloadLayerIcons: function(){
        var that = this,
            master = $.Deferred(),
            features,
            chartSize,
            canvas,
            visStyle;

        that.newArray = [];
        that._prjLayer.project.loadStructure(that._prjLayer.get('code')).then(function(arr) {
            visStyle = that._prjLayer.get('visualSettings');

            that.chartCache = {};
            that.minMaxValues = false;
            features = that._prjLayer.objects;
            // для линейных и столбчатых диаграмм нужно посчитать общую границу шкалы
            that.allPrjArray = [];
            $.each(arr, function (id, elem) {
                that.columnStyles.forEach(function (column) {
                    if (elem.id == column.id) {
                        that.newArray[column.sort] = elem.code;
                    }
                });
                that.allPrjArray[id] = elem;
            });
            if (visStyle.type == 5 || visStyle.type == 6) {
                that.minMaxScaleValues = false;
                that._getMinMaxScaleTicks(features);
            }
            features.each(function (feature) {
                chartSize = that._getChartSize(feature);
                canvas = $('<canvas width="' + chartSize.w + '" height="' + chartSize.h + '"></canvas>');

                switch (visStyle.type) {
                    case 4:
                        that._createPieChart(canvas, feature);
                        break;
                    case 5:
                        that._createBarChart(canvas, feature);
                        break;
                    case 6:
                        that._createLineChart(canvas, feature);
                        break;
                }

                that.chartCache[feature.getId()] = canvas[0];
                canvas.detach();
            });
            master.resolve(true);
        });
        return master;
    },

    setLayerStyle: function(){
        var that = this,
            chart,
            vStyle = that._prjLayer.get('visualSettings');

        that.setChartDefaults();
        // update images, then set layer style function
        return that._reloadLayerIcons().done(function(){

            // Чистим сохраненные стили
            that.styleCache = {};

            that._olLayer.setStyle(function(feature){
                var styles = [],
                    offset = [0,0],
                    featureId = feature.getId();

                var pixelRatio = that.pixelRatio ? that.pixelRatio : devPixelRatio;

                if (featureId+'' in that.styleCache) {
                    return that.styleCache[featureId+''];
                }

                chart = that.chartCache[featureId];

                if(!chart || !chart.width){
                    return false;
                }
                offset[0] = chart.width/2;
                offset[1] = chart.height/2;
                // прозрачный фон для кликанья по линейным и столбчатым графикам
                if (vStyle.type != 4 && $(chart).attr('no-data') == undefined) {
                    styles.push(new ol.style.Style({
                        image: new ol.style.RegularShape({
                            fill: new ol.style.Fill({color: 'rgba(255,255,255,0.01)'}),
                            points: 4,
                            radius: Math.sqrt((chart.width * chart.width) + (chart.height * chart.height)) / 2,
                            angle: Math.PI / 4,
                            scale:pixelRatio
                        })
                    }));
                }

                styles.push(new ol.style.Style({
                    image: new ol.style.Icon({
                        anchor: offset,
                        anchorXUnits: 'pixels',
                        anchorYUnits: 'pixels',
                        opacity: vStyle.classesSettings.opacity / 100,
                        img: chart,
                        imgSize:[chart.width, chart.height],
                        scale: pixelRatio
                    })
                }));

                if (vStyle.showText && $(chart).attr('no-data') == undefined) {
                    var need;
                    $.each(that.allPrjArray, function(index, column){
                        if (column.id == vStyle.textSettings.column){
                            need = column.code;
                        }
                    });
                    var value = (need == 'orbis_id') ? feature.getId() :  feature.get("obj").get(need);
                    value = utils.doubleUnescapeHTML(value);
                    var textSettings = {
                        font: vStyle.textSettings.fontSize + 'px sans-serif',
                        width: 2,
                        text: value == null ? '' : _.unescape(value.toString()),
                        fill: new ol.style.Fill({
                            color: that._toRgba(vStyle.textSettings.fontColor, vStyle.textSettings.fontOpacity)
                        })
                    };

                    if (vStyle.textSettings.halo) {
                        textSettings.stroke = new ol.style.Stroke({
                            color: that._toRgba(vStyle.textSettings.haloColor, vStyle.textSettings.haloOpacity),
                            width: vStyle.textSettings.haloWidth
                        })
                    }

                    if (vStyle.textSettings.offsetEnabled) {
                        textSettings.offsetY = vStyle.textSettings.textOffset;
                    }

                    styles.push(new ol.style.Style({
                        text: new ol.style.Text(textSettings)
                    }));
                }

                that.styleCache[featureId+''] = styles;
                return styles;
            });
        });
    },

    _getMinMaxScaleTicks: function(){
        var that = this,
            min = 0,
            max = 0,
            value;

        if (that.minMaxScaleValues) {
            return;
        }

        that._prjLayer.objects.each(function(feature){
            that.columnStyles.forEach(function(column){
                // if(that.newArray[column.sort] == column.id) {
                //     value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
                // }else {
                //     value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
                // }
                value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
                if (value != null) {

                    if (value) {
                        if (value < min) {
                            min = value;
                        }
                        if (value > max) {
                            max = value;
                        }
                    }
                }
            });
        });
        that.minMaxScaleValues = [min, max];
    },

    /**
     *
     */
    _getMinMaxValues: function(type){
        var that = this,
            min,
            max,
            features,
            value;
        
        if (that.minMaxValues) {
            return;
        }

        features = that._prjLayer.objects;
        if (features.length == 0) {
            return;
        }

        switch(type) {
            // сумма значений
            case 2:
                //найдем минимальное и максимальное значение по суммам
                features.each(function(feature){
                    value = false;
                    that.columnStyles.forEach(function(column){
                        var v;
                        if(that.newArray[column.sort] == column.id) {
                            v = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
                        }else {
                            v = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
                        }
                        if (v != null) {
                            value += v;
                        }
                    });

                    if (value) {
                        if (!min || value < min) {
                            min = value;
                        }
                        if (!max || value > max) {
                            max = value;
                        }
                    }
                });
                that.minMaxValues = [min, max];
                break;

            // по колонке
            case 3:
                //найдем минимальное и максимальное значение по колонке
                features.each(function(feature){
                    that.columnStyles.forEach(function(column){
                        if(that.newArray[column.sort] == that.sizeColumn) {
                            value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
                        }else {
                            value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
                        }
                        if (value != null) {
                            if (!min || value < min) {
                                min = value;
                            }
                            if (!max || value > max) {
                                max = value;
                            }
                        }
                    });
                });
                that.minMaxValues = [min, max];
                break;
        }
    },

    _getChartSize: function(feature){
        var that     = this,
            visStyle = that._prjLayer.get("visualSettings"),
            classesSettings = that._prjLayer.get("visualSettings")['classesSettings'],
            value;

        // для линейных и столбчатых диаграмм нужно посчитать ширину шкалы
        var scaleWidth = 0;

        if (visStyle.type == 5 || visStyle.type == 6) {
            // если шкала включена, считаем, сколько она должна занять места
            if (classesSettings.showScale) {
                scaleWidth = Math.max(that.minMaxScaleValues[0].toString().length + 1, that.minMaxScaleValues[1].toString().length + 1) * 5;
            }
        }

        if (classesSettings.sizeType == 1) {
            // для фиксированного графика сразу возвращаем размеры
            return {w: classesSettings.sizeValue + scaleWidth, h: classesSettings.sizeValue};
        } else {
            // иначе ищем мин макс значения среди всех фич в зависимости от типа графика
            that._getMinMaxValues(classesSettings.sizeType);
            if (that.minMaxValues[1] == that.minMaxValues[0]) {
                // если не смогли найти мин макс, берем средний арифметический размер графика
                var size = (classesSettings.sizeTo - classesSettings.sizeFrom) / 2;
                return {w: size + scaleWidth, h: size};
            }
        }

        // считаем значение конкретной фичи, чтобы потом рассчитать пропорцию
        if (classesSettings.sizeType == 2) {
            value = 0;
            that.columnStyles.forEach(function(column){
                var v;
                if(that.newArray[column.sort] == column.id) {
                    v = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
                }else {
                    v = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
                }
                if (v != null) {
                    value += v;
                }

            });
        } else if (classesSettings.sizeType == 3) {
            that.columnStyles.forEach(function(column) {
                if (that.newArray[column.sort] == that.sizeColumn) {
                    value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() : feature.get(that._prjLayer.get('visualSettings').columnCode);
                } else {
                    value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
                }
            });
        }

        //считаем размер графика в пропорции
        var sizeDelta = classesSettings.sizeTo - classesSettings.sizeFrom;
        var chartSize = parseInt(classesSettings.sizeFrom + sizeDelta * (value - that.minMaxValues[0]) / (that.minMaxValues[1] - that.minMaxValues[0]));

        return {w: chartSize + scaleWidth, h: chartSize};
    },

    _toRgba: function(hex, opacity){
        var startPos = 0;
        if(~hex.indexOf("#")){startPos = 1}
        var r = parseInt(hex.substr((0 + startPos), 2), 16);
        var g = parseInt(hex.substr((2 + startPos), 2), 16);
        var b = parseInt(hex.substr((4 + startPos), 2), 16);
        return "rgba(" + ((r.toString().length == 1) ? '0' + r : r) + ", " + ((g.toString().length == 1) ? '0' + g
                : g) + ", " + ((b.toString().length == 1) ? '0' + b : b) + ", " + opacity / 100 + ")";
    },

    show: function() {
        var that = this;
        that._prjLayer.set('selected', true);
        if (that.loadOptions) {
            that._prjLayer.loadObjects(that.loadOptions)
                .then(function () {
                    that.loadOptions = undefined;
                    that._setup({
                        projectLayers: that._prjLayers
                    });
                    if (that._prjLayer.get('selected')) {
                        OmsChartsLayer.__super__.show.call(that);
                    }
                });
        } else {
            OmsChartsLayer.__super__.show.call(that);
        }
    },

    hide: function() {
        var that = this;
        that._prjLayer.set('selected', false);
        OmsChartsLayer.__super__.hide.call(that);
    }
});

module.exports = OmsChartsLayer;


//////////////////
// WEBPACK FOOTER
// ./src/View/OmsChartsLayer.js
// module id = 53
// module chunks = 0